import React from "react";
import Customize from "../../../../../../../../components/controllers/shared/helpers/customize";
import { Link } from "react-router-dom";

export type ListProps = {
	item: any;
	companyName: string;
	mobile?: true;
};

const List: React.FC<ListProps> = ({ item, companyName, mobile }) => {
	const url = Customize.planUrl(item.url);
	const isMobile = mobile || false;

	if (item.target === "_blank") {
		return (
			<li className={`${isMobile && "list-group-item-mobile"}`}>
				<a
					href={url}
					target="_blank"
					rel="noopener noreferrer"
					style={{
						textDecoration: "none",
						lineHeight: 1,
					}}
					className={`${!isMobile && "myAccountLinks"}`}
				>
					{item.displayName}
				</a>
			</li>
		);
	}

	return (
		<li className={`${isMobile && "list-group-item-mobile"}`}>
			<Link
				to={url}
				style={{
					textDecoration: "none",
					lineHeight: 1,
				}}
				className={`${!isMobile && "myAccountLinks"}`}
			>
				<div
					style={{
						border: "1px solid #616267",
						borderRadius: "4px",
						padding: "6px 8px",
						marginBottom: "8px",
						color: "#616267",
						background: "#f6f6f8",
						width: "fit-content",
						fontWeight: "600",
						fontSize: "14px",
					}}
				>
					{item.displayName}
				</div>
				{companyName} {item.planName}
			</Link>
		</li>
	);
};

export default List;
